module.exports = __webpack_public_path__ + "img/revoke_latex.4fbe9e8d.svg";